module.exports = __webpack_public_path__ + "static/img/tongyiliucheng.b08a62a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/tongyiliucheng.gif
// module id = CpcO
// module chunks = 0